import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivationPageComponent } from './components/activation-page/activation-page.component';
import { ConfirmationPageComponent } from './components/confirmation-page/confirmation-page.component';
import { LostPwPageComponent } from './components/lost-pw-page/lost-pw-page.component';
import { NewEmailPageComponent } from './components/new-email-page/new-email-page.component';
import { PermissionsPageComponent } from './components/permissions-page/permissions-page.component';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { RegisterPageComponent } from './components/register-page/register-page.component';
import { SignInPageComponent } from './components/sign-in-page/sign-in-page.component';
import { SignOutPageComponent } from './components/sign-out-page/sign-out-page.component';
import {AdminPageComponent} from "./components/admin-page/admin-page.component";

const routes: Routes = [
  { path: '', component: SignInPageComponent },
  { path: 'willkommen', component: PermissionsPageComponent },
  { path: 'profil', component: ProfilePageComponent },
  { path: 'zugaenge', component: PermissionsPageComponent },
  { path: 'nutzer-verwaltung', component: AdminPageComponent },
  { path: 'einladungs-code/:hash', component: PermissionsPageComponent },
  { path: 'passwort-vergessen', component: LostPwPageComponent },
  { path: 'neue-email', component: NewEmailPageComponent },
  { path: 'neue-email/angefordert', component: ConfirmationPageComponent },
  { path: 'email-validierung', component: ActivationPageComponent },
  { path: 'email-validierung/erfolgreich', component: ConfirmationPageComponent },
  { path: 'email-validierung/:key', component: ActivationPageComponent },
  { path: 'neues-passwort', component: ActivationPageComponent },
  { path: 'neues-passwort/erfolgreich', component: ConfirmationPageComponent },
  { path: 'neues-passwort/angefordert', component: ConfirmationPageComponent },
  { path: 'neues-passwort/:key', component: ActivationPageComponent },
  { path: 'aktivierung', component: ActivationPageComponent },
  { path: 'aktivierung/erfolgreich', component: ConfirmationPageComponent },
  { path: 'aktivierung/:key', component: ActivationPageComponent },
  { path: 'registrieren', component: RegisterPageComponent },
  { path: 'registrieren/erfolgreich', component: ConfirmationPageComponent },
  { path: 'anmelden/:clientId', component: SignInPageComponent },
  { path: 'abmelden/:clientId', component: SignOutPageComponent },
  { path: ':uid', component: SignInPageComponent },

  { path: 'einladungscode/:hash', redirectTo: 'einladungs-code/:hash', pathMatch: 'full' },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
